import React from 'react';

const MobileCard = ({ 
  children, 
  className = "", 
  padding = "p-4 md:p-6",
  shadow = "shadow-sm",
  rounded = "rounded-xl",
  background = "bg-white",
  border = "border border-gray-200",
  ...props
}) => {
  return (
    <div
      {...props}
      className={`
      ${background}
      ${padding}
      ${shadow}
      ${rounded}
      ${border}
      transition-all duration-200
      hover:shadow-md
      ${className}
    `}
    >
      {children}
    </div>
  );
};

export default MobileCard;
